import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RxButtonModule } from '../../../button/button.module';

@Component({
  imports: [CommonModule, RxButtonModule],
  standalone: true,
  selector: 'rx-calendar-footer',
  templateUrl: './calendar-footer.component.html',
    styleUrls: ['./calendar-footer.component.scss'],
})
export class CalendarFooterComponent {
  @Input() startDate: Date | null = null;
  @Input() endDate: Date | null = null;
  @Input() dateFormat = 'MM/dd/yyyy';
  @Input() resetText: string;
  @Input() applyText: string;
  @Input() testIdPrefix: string;

  @Output() clickReset = new EventEmitter<void>();
  @Output() clickApply = new EventEmitter<void>();
}
